import { render, staticRenderFns } from "./signinorregister.vue?vue&type=template&id=74c7efc3"
import script from "./signinorregister.vue?vue&type=script&lang=js"
export * from "./signinorregister.vue?vue&type=script&lang=js"
import style0 from "./signinorregister.vue?vue&type=style&index=0&id=74c7efc3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports